import type { AppState } from '../../store/types';
import type {
  AiMetadataBulkReviewRequest,
  AiMetadataGeneration,
} from './types';

export const getAiMetadataGenerationKey = (
  assetId: string,
  versionId: string,
): string => `${assetId}|${versionId}`;

export const getAiMetadataGeneration = (
  state: AppState,
  assetId: string | undefined,
  versionId: string | undefined,
): AiMetadataGeneration | undefined => {
  if (!assetId || !versionId) {
    return undefined;
  }
  return state.aiMetadata.generations[
    getAiMetadataGenerationKey(assetId, versionId)
  ];
};

export const findAiMetadataGenerationForAsset = (
  state: AppState,
  assetId: string | undefined,
  predicate?: (entry: AiMetadataGeneration) => boolean,
): AiMetadataGeneration | undefined => {
  if (!assetId) {
    return undefined;
  }
  for (const entry of Object.values(state.aiMetadata.generations)) {
    if (entry.assetId !== assetId) {
      continue;
    }
    if (predicate && !predicate(entry)) {
      continue;
    }
    return entry;
  }
  return undefined;
};

export const findAiMetadataGenerationByJobId = (
  state: AppState,
  jobId: string | undefined,
): AiMetadataGeneration | undefined => {
  if (!jobId) {
    return undefined;
  }
  for (const entry of Object.values(state.aiMetadata.generations)) {
    if (entry.jobId === jobId) {
      return entry;
    }
  }
  return undefined;
};

export const getBulkReviewRequest = (
  state: AppState,
  parentJobId: string | undefined,
): AiMetadataBulkReviewRequest | undefined =>
  parentJobId ? state.aiMetadata.bulkReviewRequests[parentJobId] : undefined;
